export var source_system_alert = { "uid": "source_system_alert", "fields": { "title": { "defaultValue": "" }, "alert_title": { "defaultValue": "" }, "description": { "defaultValue": "" } } };
